import { useState, useEffect } from "react";
import axios, { AxiosResponse, AxiosError } from "axios";
// import { apibaseurl, jwttoken } from "../../environment";
import { useNavigate } from "react-router";
import { apibaseurl, jwttoken } from "../environment";

interface ApiOptions {
    method?: "GET" | "POST" | "DELETE";
    payload?: Record<string, any> | null;
    autoCall?: boolean;
    dependencies?: any[];
}

interface UseApiResult<T> {
    data: T | null;
    loading: boolean;
    error: any;
    callApi: (
        payload?: Record<string, any>,
        customUrl?: string
    ) => Promise<T | undefined>;
}

function useApi<T = any>(endpoint: string, { method = "GET", payload = null, autoCall = true, dependencies = [], }: ApiOptions = {}): UseApiResult<T> {
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState<boolean>(autoCall);
    const [error, setError] = useState<any>(null);
    const navigate = useNavigate();

    const callApi = async (customPayload = payload, customUrl?: string): Promise<T | undefined> => {
        setLoading(true);
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${(jwttoken ?? localStorage.getItem("token")) || ""
                        }`,
                },
                data: method === "DELETE" ? customPayload : undefined,
            };

            let response: AxiosResponse<any>;
            const finalUrl = `${apibaseurl}${customUrl ?? endpoint}`;
            if (method === "POST") {
                response = await axios.post(
                    `${apibaseurl}${endpoint}`,
                    customPayload,
                    config
                );
            } else if (method === "DELETE") {
                response = await axios.delete(`${finalUrl}`, config);
            } else {
                response = await axios.get(`${apibaseurl}${endpoint}`, config);
            }

            setData(response.data);
            setError(null);
            return response.data;
        } catch (err: unknown) {
            console.error("API Error:", err);
            setError(err);
            if (axios.isAxiosError(err)) {
                if (err.message === "Network Error") {
                    navigate("/network-error");
                } else if (err.response?.status === 500) {
                    navigate("/error-500");
                } else {
                    throw err;
                }
            } else {
                throw err;
            }
        } finally {
            setTimeout(() => setLoading(false), 500);
            //setLoading(false);
        }
    };

    useEffect(() => {
        if (autoCall) {
            callApi();
        }
    }, dependencies);

    return { data, loading, error, callApi };
}

export default useApi;

// import { useState, useEffect } from "react";
// import axios, { AxiosResponse } from "axios";
// import { apibaseurl, jwttoken } from "../../environment";

// interface ApiOptions {
//   method?: "GET" | "POST";
//   payload?: Record<string, any> | null;
//   autoCall?: boolean;
//   dependencies?: any[];
// }

// interface UseApiResult<T> {
//   data: T | null;
//   loading: boolean;
//   error: any;
//   callApi: () => Promise<void>;
// }

// function useApi<T = any>(
//   endpoint: string,
//   {
//     method = "GET",
//     payload = null,
//     autoCall = true,
//     dependencies = [],
//   }: ApiOptions = {}
// ): UseApiResult<T> {
//   const [data, setData] = useState<T | null>(null);
//   const [loading, setLoading] = useState<boolean>(autoCall);
//   const [error, setError] = useState<any>(null);

//   const callApi = async (): Promise<void> => {
//     setLoading(true);
//     try {
//       const config = {
//         headers: {
//           Authorization: `Bearer ${jwttoken}`,
//         },
//       };

//       let response: AxiosResponse<any>;

//       if (method === "POST") {
//         response = await axios.post(
//           `${apibaseurl}${endpoint}`,
//           payload,
//           config
//         );
//       } else {
//         response = await axios.get(`${apibaseurl}${endpoint}`, config);
//       }

//       setData(response.data);
//       setError(null);
//       return response.data;
//     } catch (err) {
//       console.error("API Error:", err);
//       setError(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (autoCall) {
//       callApi();
//     }
//   }, dependencies);

//   return { data, loading, error, callApi };
// }

// export default useApi;

// import { useState, useEffect } from "react";
// import axios from "axios";
// import { apibaseurl, jwttoken } from "../../environment";

// function useApi(endpoint, { method = "GET", payload = null, autoCall = true, dependencies = [], } = {}) {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(autoCall);
//   const [error, setError] = useState(null);

//   const callApi = async () => {
//     setLoading(true);
//     try {
//       const config = {
//         headers: {
//           Authorization: `Bearer ${jwttoken}`,
//         },
//       };

//       let response;

//       if (method === "POST") {
//         response = await axios.post(`${apibaseurl}${endpoint}`, payload, config);
//       } else {
//         response = await axios.get(`${apibaseurl}${endpoint}`, config);
//       }

//       setData(response.data);
//       setError(null);
//     } catch (err) {
//       console.error("API Error:", err);
//       setError(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (autoCall) {
//       callApi();
//     }
//   }, dependencies);

//   return { data, loading, error, callApi };
// }

// export default useApi;
